const authEndpoint = "https://accounts.spotify.com/authorize";
const redirectUri = "https://spotify-react1.web.app/";
const clientId = "35cb3c1071bc4b1899358cadd612d6ef";

const scopes = [
  "user-read-playback-state",
  "user-read-recently-played",
  "user-read-currently-playing",
  "user-modify-playback-state",
  "user-top-read",
];

export const getTokenFromResponse = () => {
  return window.location.hash
    .substring(1)
    .split("&")
    .reduce((initial, item) => {
      let parts = item.split("=");
      initial[parts[0]] = decodeURIComponent(parts[1]);
      return initial;
    }, {});
};
export const loginUrl = `${authEndpoint}?client_id=${clientId}&redirect_uri=${redirectUri}&scope=${scopes.join(
  "%20"
)}&response_type=token&show_dialog=true`;
